import {useHttp} from "./http.hook";
import {StatusEmailParserTypes} from "../shared/types";

const parser = new DOMParser();

interface IData {
    message: string,
}

interface IDataHtml {
    message: string,
    info: string
}

interface IDataStatus {
    message: string,
    info: StatusEmailParserTypes
}

interface IDataLink {
    message: string,
    info: ILink[]
}

interface ILink {
    url: string
    email: string
}

export const useEmailParsing = () => {

    const {loading, request, error, clearError} = useHttp()

    //отправка списка адресов сайтов и запуск парсинга email адресов
    const sendUrlList = async (links: ILink[]) => {
        try {
            const data: IData = await request('/api/email-parsing/start-email-parsing', 'POST', {
                links: links,
            })
            return data
        } catch (e) {
            throw new Error('Ошибка отправки данных.')
        }
    }

    //получение статуса работы парсера
    const getStatus = async () => {
        try {
            const data: IDataStatus = await request('/api/email-parsing/get-status-parser', 'POST', {})
            return data
        } catch (e) {
            throw new Error('Ошибка отправки данных.')
        }
    }

    //принудительная остановка парсера
    const stopParser = async () => {
        try {
            const data: IData = await request('/api/email-parsing/stop-email-parser', 'POST', {})
            return data
        } catch (e) {
            throw new Error('Ошибка отправки данных.')
        }
    }

    //парсинг ссылок на сайты с html кода страницы органического поиска Google
    const linkParseFromHtml = (htmlString: string) => {
        const linkArr: string[] = []
        const domFromHtml = parser.parseFromString(htmlString, "text/html");
        const wrapLinks = domFromHtml.querySelector(".dURPMd")
        const links = wrapLinks?.querySelectorAll(".MjjYud > .A6K0A > .wHYlTd")
        links?.forEach((linkElem) => {
            const link = linkElem.querySelector("a")?.href
            if (link) {
                //очистим ссылку от параметров
                const splitLink = link?.split("/")
                const domain = splitLink[0] + '//' + splitLink[2]
                linkArr.push(domain)
            }
        })
        return linkArr
    }

    //получение спаршеного списка email адресов
    const getEmailListFromParser = async () => {
        try {
            const data: IDataLink = await request('/api/email-parsing/get-email-list-from-parser', 'POST', {})
            return data
        } catch (e) {
            throw new Error('Ошибка отправки данных.')
        }
    }

    return {
        loading,
        sendUrlList,
        getStatus,
        stopParser,
        getEmailListFromParser,
        linkParseFromHtml,
        error,
        clearError
    }
}